import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { deleteQueryRequest, deleteQueryRequestError, deleteQueryRequestSuccess } from '../../slices/Query/DeleteQuerySlice';

export const DeleteQueryAPI = (id) => {
    const url = `${endpoints.deleteQuery}/${id}`;
    return async (dispatch) => {
        try {
            dispatch(deleteQueryRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "DELETE",
                url: url,
            })
            return dispatch(deleteQueryRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(deleteQueryRequestError(_error));
        }
    };
};
